import React from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import CommissionDetailRow from 'src/models/personnel/CommissionDetailRow';

interface IPmLandmenDialogProps {
    dialogName: string;
    pmName?: string;
    items: Array<CommissionDetailRow>;
    onClose: () => void;
}

const formatCurrency = (value: number) =>
    (value ?? 0).toLocaleString('en-US', { style: 'currency', currency: 'USD' });

// Mirrors CommissionPage's own Comm_Days highlight (GET_TSD_LANDMAN [oid 134]) - not a copy, the
// same rule: green when comm_days > 0 and margin_rate > 0, red otherwise.
const commDaysColor = (row: CommissionDetailRow) => (
    (row.commDays ?? 0) > 0 && (row.marginRate ?? 0) > 0 ? '#8ee88e' : '#f5a3a3'
);

// New feature (2026-09-16), not an Oracle port - a VP-scoped Manager/Crew Chief search can show a
// subordinate Area Manager's row, whose own Commission Detail lists their PMs (each PM's production
// rolled up to the Area Manager). Double-clicking one of those PM rows opens this dialog, looking
// the PM's own tsd_no up as a manager in its own right (GET Commission/detail-by-manager) to show
// THEIR OWN Commission Detail - the actual landmen under them - in the identical grid shape as the
// page's own Commission Detail panel.
const PmLandmenDialog = (props: IPmLandmenDialogProps) => {
    return (
        <Dialog
            title={props.pmName ? `Landmen Under ${props.pmName}` : 'Landmen'}
            dialogName={props.dialogName}
            bodyStyle={{ width: '75%' }}
            isExitButtonInvisible={true}
        >
            <div style={{ maxHeight: '60vh', overflowY: 'auto', overflowX: 'auto' }}>
                <table style={{ width: '100%', borderSpacing: 0, borderCollapse: 'separate' }}>
                    <thead>
                        <tr>
                            <th style={{ whiteSpace: 'nowrap' }}>Client</th>
                            <th style={{ whiteSpace: 'nowrap' }}>Project</th>
                            <th style={{ whiteSpace: 'nowrap' }}>Subcode</th>
                            <th style={{ whiteSpace: 'nowrap' }}>Employee #</th>
                            <th style={{ whiteSpace: 'nowrap' }}>Landman Name</th>
                            <th style={{ whiteSpace: 'nowrap' }}>Bill Rate</th>
                            <th style={{ whiteSpace: 'nowrap' }}>Day Rate</th>
                            <th style={{ whiteSpace: 'nowrap' }}>Margin Rate</th>
                            <th style={{ whiteSpace: 'nowrap' }}>Days</th>
                            <th style={{ whiteSpace: 'nowrap' }}>Margin Type</th>
                            <th style={{ whiteSpace: 'nowrap' }}>Margin Amount</th>
                            <th style={{ whiteSpace: 'nowrap' }}>Invoice #</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.items.map((row, index) => (
                            <tr key={`${row.commId}-${row.clNo}-${row.prNo}-${row.tsdNo}-${index}`} style={{ textAlign: 'center' }}>
                                <td className="arHistoryCell">{row.clNo}</td>
                                <td className="arHistoryCell">{row.prNo}</td>
                                <td className="arHistoryCell">{row.scNo}</td>
                                <td className="arHistoryCell">{row.tsdNo}</td>
                                <td className="arHistoryCell">{row.name}</td>
                                <td className="arHistoryCell" style={{ textAlign: 'right' }}>{formatCurrency(row.billRate)}</td>
                                <td className="arHistoryCell" style={{ textAlign: 'right' }}>{formatCurrency(row.dayRate)}</td>
                                <td className="arHistoryCell" style={{ textAlign: 'right' }}>{formatCurrency(row.marginRate)}</td>
                                <td className="arHistoryCell" style={{ backgroundColor: commDaysColor(row) }}>{row.commDays}</td>
                                <td className="arHistoryCell">{row.dCommType}</td>
                                <td className="arHistoryCell" style={{ textAlign: 'right' }}>{formatCurrency(row.marginAmt)}</td>
                                <td className="arHistoryCell">{row.invoiceNo}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="button-row" style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
                <Button className="blue-hover-button" style={{ width: '10rem' }} text="Close" onClick={() => props.onClose()} />
            </div>
        </Dialog>
    );
};

export default PmLandmenDialog;



// WEBPACK FOOTER //
// ./src/components/personnel/dialogs/PmLandmenDialog.tsx